(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["material-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('velune-material-carousel-lite')) {
  customElements.define('velune-material-carousel-lite', class extends HTMLElement {
    connectedCallback() {
      if (this._mountFrame) return;
      this._mountFrame = requestAnimationFrame(() => {
        this._mountFrame = 0;
        this.mount();
      });
    }

    mount() {
      if (this.controller || !this.isConnected) return;

      this.carousel = this.querySelector('[data-mc-carousel]');
      this.cards = Array.from(this.querySelectorAll('[data-mc-card]'));

      if (!this.carousel || !this.cards.length) return;

      this.controller = new AbortController();
      const signal = this.controller.signal;

      this.interval = Math.max(2000, Number(this.dataset.interval) || 3000);
      this.lead = Math.max(0, Number(this.dataset.lead) || 0);
      this.autoplay = this.dataset.autoplay !== 'false';
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.activeIndex = 0;
      this.activeCard = this.cards[0];
      this.openCard = null;
      this.visible = false;
      this.interacting = false;
      this.dragging = false;
      this.jumping = false;
      this.isAnimating = false;
      this.dragId = null;

      if (this.cards.length > 1) this.addEdgeClones();
      this.trackCards = Array.from(this.carousel.querySelectorAll('.mc-card'));

      this.carousel.addEventListener('scroll', () => this.onScroll(), {
        passive: true,
        signal
      });

      this.carousel.addEventListener('pointerdown', (event) => {
        this.beginInteraction();

        if (
          event.pointerType !== 'mouse' ||
          event.button !== 0 ||
          event.target.closest('button, a, input, select, textarea')
        ) return;

        this.dragging = true;
        this.dragId = event.pointerId;
        this.dragX = event.clientX;
        this.dragScroll = this.carousel.scrollLeft;
        this.carousel.classList.add('mc-dragging');

        try { this.carousel.setPointerCapture(event.pointerId); } catch {}
      }, { passive: true, signal });

      this.carousel.addEventListener('pointermove', (event) => {
        if (!this.dragging || event.pointerId !== this.dragId) return;
        this.carousel.scrollLeft = this.dragScroll - (event.clientX - this.dragX);
        event.preventDefault();
      }, { passive: false, signal });

      const endPointer = (event) => {
        if (this.dragging && (this.dragId === null || event.pointerId === this.dragId)) {
          this.dragging = false;
          this.carousel.classList.remove('mc-dragging');

          try {
            if (this.carousel.hasPointerCapture(event.pointerId)) {
              this.carousel.releasePointerCapture(event.pointerId);
            }
          } catch {}

          this.dragId = null;
          this.center(this.closestCard(), this.reduced.matches ? 'auto' : 'smooth');
        }

        this.endInteraction();
      };

      this.carousel.addEventListener('pointerup', endPointer, { passive: true, signal });
      this.carousel.addEventListener('pointercancel', endPointer, { passive: true, signal });

      this.carousel.addEventListener('wheel', (event) => {
        const horizontal = Math.abs(event.deltaX) > Math.abs(event.deltaY);
        const shifted = event.shiftKey && Math.abs(event.deltaY) > 0;

        if (!horizontal && !shifted) return;

        event.preventDefault();
        this.beginInteraction();
        this.carousel.scrollLeft += horizontal ? event.deltaX : event.deltaY;
        this.endInteraction();
      }, { passive: false, signal });

      this.carousel.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.closeDetails();
          this.beginInteraction();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
          this.endInteraction();
        } else if (event.key === 'Escape') {
          this.closeDetails(true);
        }
      }, { signal });

      this.addEventListener('click', (event) => this.onClick(event), { signal });

      document.addEventListener('visibilitychange', () => {
        document.hidden ? this.stopAuto() : this.scheduleAuto();
      }, { signal });

      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          this.center(this.cards[this.activeIndex] || this.cards[0], 'auto');
          this.scheduleAuto();
        }, 100);
      }, { passive: true, signal });

      if ('IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver((entries) => {
          this.visible = Boolean(entries[0]?.isIntersecting);
          this.visible ? this.scheduleAuto() : this.stopAuto();
        }, {
          threshold: 0.01,
          rootMargin: `${this.lead}px 0px`
        });

        this.visibilityObserver.observe(this);
      } else {
        this.visible = true;
      }

      this.center(this.cards[0], 'auto');
      this.carousel.classList.add('mc-ready');
      this.ready = true;
      this.scheduleAuto();
    }

    addEdgeClones() {
      const count = this.cards.length;
      this.leadingExtra = this.cloneCard(this.cards[count - 2]);
      this.leading = this.cloneCard(this.cards[count - 1]);
      this.trailing = this.cloneCard(this.cards[0]);
      this.trailingExtra = this.cloneCard(this.cards[1]);

      this.carousel.prepend(this.leadingExtra, this.leading);
      this.carousel.append(this.trailing, this.trailingExtra);
    }

    cloneCard(card) {
      const clone = card.cloneNode(true);

      clone.dataset.mcClone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('role');
      clone.removeAttribute('aria-label');
      clone.removeAttribute('data-shopify-editor-block');
      clone.classList.remove('mc-active', 'mc-show-info');

      clone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));

      clone.querySelectorAll('[aria-controls], [aria-labelledby]').forEach((node) => {
        node.removeAttribute('aria-controls');
        node.removeAttribute('aria-labelledby');
      });

      clone.querySelectorAll('button, a, input, select, textarea').forEach((node) => {
        node.tabIndex = -1;
      });

      clone.querySelectorAll('[data-mc-details]').forEach((node) => {
        node.setAttribute('aria-hidden', 'true');
      });

      clone.querySelectorAll('[data-mc-open]').forEach((node) => {
        node.setAttribute('aria-expanded', 'false');
      });

      clone.querySelectorAll('img').forEach((image) => {
        image.loading = 'lazy';
        image.decoding = 'async';
      });

      return clone;
    }

    closestCard() {
      const center = this.carousel.scrollLeft + this.carousel.clientWidth / 2;
      let closest = null;
      let best = Infinity;

      for (const card of this.trackCards) {
        const distance = Math.abs(
          card.offsetLeft + card.offsetWidth / 2 - center
        );

        if (distance < best) {
          best = distance;
          closest = card;
        }
      }

      return closest;
    }

    setActive(card) {
      if (!card) return;

      const index = Number(card.dataset.index);
      if (Number.isFinite(index)) this.activeIndex = index;

      if (card === this.activeCard) return;

      this.activeCard?.classList.remove('mc-active');
      card.classList.add('mc-active');
      this.activeCard = card;
    }

    cancelSlide() {
      cancelAnimationFrame(this.slideRaf);
      this.slideRaf = 0;
      this.isAnimating = false;
      this.carousel.classList.remove('mc-animating');
    }

    center(card, behavior = 'smooth') {
      if (!card) return;

      const target = Math.max(0, Math.min(
        this.carousel.scrollWidth - this.carousel.clientWidth,
        card.offsetLeft - (this.carousel.clientWidth - card.offsetWidth) / 2
      ));
      const start = this.carousel.scrollLeft;
      const distance = target - start;

      this.cancelSlide();
      clearTimeout(this.scrollTimer);

      if (behavior !== 'smooth' || this.reduced.matches || Math.abs(distance) < 1) {
        this.carousel.scrollLeft = target;
        this.setActive(card);
        if (this.ready) this.finishScroll();
        return;
      }

      // Scroll via requestAnimationFrame to control speed and direction reliably.
      this.isAnimating = true;
      this.carousel.classList.add('mc-animating');

      const duration = 920;
      let startedAt = null;

      const animate = (now) => {
        if (startedAt === null) startedAt = now;
        const progress = Math.min((now - startedAt) / duration, 1);
        const eased = progress * progress * (3 - 2 * progress);
        this.carousel.scrollLeft = start + distance * eased;

        if (progress < 1) {
          this.slideRaf = requestAnimationFrame(animate);
          return;
        }

        this.slideRaf = 0;
        this.carousel.scrollLeft = target;
        this.isAnimating = false;
        this.finishScroll();
        this.carousel.classList.remove('mc-animating');
        this.scheduleAuto();
      };

      this.slideRaf = requestAnimationFrame(animate);
    }

    move(direction) {
      if (this.cards.length < 2 || this.jumping) return;

      const index = this.activeIndex;
      let target;

      if (direction > 0) {
        target = index >= this.cards.length - 1
          ? this.trailing
          : this.cards[index + 1];
      } else {
        target = index <= 0
          ? this.leading
          : this.cards[index - 1];
      }

      this.center(target, this.reduced.matches ? 'auto' : 'smooth');
    }

    onScroll() {
      if (this.jumping) return;

      if (!this.scrollRaf) {
        this.scrollRaf = requestAnimationFrame(() => {
          this.scrollRaf = 0;
          if (!this.jumping) this.setActive(this.closestCard());
        });
      }

      clearTimeout(this.scrollTimer);
      // Never interrupt a running slide to snap instantly to a clone.
      if (!this.isAnimating && !this.dragging) {
        this.scrollTimer = setTimeout(() => this.finishScroll(), 180);
      }
    }

    finishScroll() {
      if (this.isAnimating || this.dragging || this.jumping) return;

      const card = this.closestCard();
      if (!card) return;

      this.setActive(card);
      if (!card.dataset.mcClone) return;

      const index = Number(card.dataset.index);
      const realCard = this.cards[Number.isFinite(index) ? index : 0];
      if (!realCard) return;

      // The extra edge clones make the visible neighbours match on both sides,
      // so the internal infinite-loop reset is not perceptible.
      this.jumping = true;
      this.carousel.classList.add('mc-loop-reset');
      void this.carousel.offsetWidth;
      this.carousel.scrollLeft = realCard.offsetLeft -
        (this.carousel.clientWidth - realCard.offsetWidth) / 2;
      this.setActive(realCard);

      cancelAnimationFrame(this.loopRaf);
      this.loopRaf = requestAnimationFrame(() => {
        this.loopRaf = 0;
        this.carousel.classList.remove('mc-loop-reset');
        this.jumping = false;
        this.scheduleAuto();
      });
    }

    canAuto() {
      return (
        this.autoplay &&
        this.cards.length > 1 &&
        this.ready &&
        this.visible &&
        !document.hidden &&
        !this.interacting &&
        !this.openCard &&
        !this.dragging &&
        !this.isAnimating &&
        !this.jumping
      );
    }

    stopAuto() {
      clearTimeout(this.autoTimer);
      this.autoTimer = 0;
    }

    scheduleAuto() {
      this.stopAuto();
      if (!this.canAuto()) return;

      this.autoTimer = setTimeout(() => {
        this.autoTimer = 0;

        if (!this.canAuto()) {
          this.scheduleAuto();
          return;
        }

        this.move(1);
      }, this.interval);
    }

    beginInteraction() {
      this.interacting = true;

      this.cancelSlide();

      clearTimeout(this.interactionTimer);
      this.stopAuto();
    }

    endInteraction() {
      clearTimeout(this.interactionTimer);

      this.interactionTimer = setTimeout(() => {
        this.interacting = false;
        this.scheduleAuto();
      }, 900);
    }

    onClick(event) {
      const prev = event.target.closest('[data-mc-prev]');
      const next = event.target.closest('[data-mc-next]');
      const open = event.target.closest('[data-mc-open]');
      const close = event.target.closest('[data-mc-close]');

      if (prev || next) {
        this.closeDetails();
        this.beginInteraction();
        this.move(next ? 1 : -1);
        this.endInteraction();
        return;
      }

      if (open) {
        const card = open.closest('[data-mc-card]');
        if (!card || card.dataset.mcClone) return;

        this.openDetails(card, open);
        return;
      }

      if (close) {
        const card = close.closest('[data-mc-card]');
        if (card) this.closeDetails(true, card);
      }
    }

    openDetails(card, button) {
      if (this.openCard && this.openCard !== card) {
        this.closeDetails(false);
      }

      this.center(card, this.reduced.matches ? 'auto' : 'smooth');

      card.classList.add('mc-show-info');
      button.classList.add('mc-hidden');
      button.setAttribute('aria-expanded', 'true');

      card.querySelector('[data-mc-details]')
        ?.setAttribute('aria-hidden', 'false');

      this.openCard = card;
      this.stopAuto();
    }

    closeDetails(focus = false, card = this.openCard) {
      if (!card) return;

      card.classList.remove('mc-show-info');

      const button = card.querySelector('[data-mc-open]');
      button?.classList.remove('mc-hidden');
      button?.setAttribute('aria-expanded', 'false');

      card.querySelector('[data-mc-details]')
        ?.setAttribute('aria-hidden', 'true');

      if (this.openCard === card) this.openCard = null;
      if (focus) button?.focus();

      this.scheduleAuto();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this._mountFrame);
      cancelAnimationFrame(this.scrollRaf);
      cancelAnimationFrame(this.slideRaf);
      cancelAnimationFrame(this.loopRaf);

      clearTimeout(this.autoTimer);
      clearTimeout(this.interactionTimer);
      clearTimeout(this.scrollTimer);
      clearTimeout(this.resizeTimer);

      this.visibilityObserver?.disconnect();
      this.controller?.abort();

      this.leadingExtra?.remove();
      this.leading?.remove();
      this.trailing?.remove();
      this.trailingExtra?.remove();

      this.controller = null;
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velune-accessories-material-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('velune-material-carousel-lite')) {
  customElements.define('velune-material-carousel-lite', class extends HTMLElement {
    connectedCallback() {
      if (this._mountFrame) return;
      this._mountFrame = requestAnimationFrame(() => {
        this._mountFrame = 0;
        this.mount();
      });
    }

    mount() {
      if (this.controller || !this.isConnected) return;

      this.carousel = this.querySelector('[data-mc-carousel]');
      this.cards = Array.from(this.querySelectorAll('[data-mc-card]'));

      if (!this.carousel || !this.cards.length) return;

      this.controller = new AbortController();
      const signal = this.controller.signal;

      this.interval = Math.max(2000, Number(this.dataset.interval) || 3000);
      this.lead = Math.max(0, Number(this.dataset.lead) || 0);
      this.autoplay = this.dataset.autoplay !== 'false';
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.activeIndex = 0;
      this.activeCard = this.cards[0];
      this.openCard = null;
      this.visible = false;
      this.interacting = false;
      this.dragging = false;
      this.jumping = false;
      this.isAnimating = false;
      this.dragId = null;

      if (this.cards.length > 1) this.addEdgeClones();
      this.trackCards = Array.from(this.carousel.querySelectorAll('.mc-card'));

      this.carousel.addEventListener('scroll', () => this.onScroll(), {
        passive: true,
        signal
      });

      this.carousel.addEventListener('pointerdown', (event) => {
        this.beginInteraction();

        if (
          event.pointerType !== 'mouse' ||
          event.button !== 0 ||
          event.target.closest('button, a, input, select, textarea')
        ) return;

        this.dragging = true;
        this.dragId = event.pointerId;
        this.dragX = event.clientX;
        this.dragScroll = this.carousel.scrollLeft;
        this.carousel.classList.add('mc-dragging');

        try { this.carousel.setPointerCapture(event.pointerId); } catch {}
      }, { passive: true, signal });

      this.carousel.addEventListener('pointermove', (event) => {
        if (!this.dragging || event.pointerId !== this.dragId) return;
        this.carousel.scrollLeft = this.dragScroll - (event.clientX - this.dragX);
        event.preventDefault();
      }, { passive: false, signal });

      const endPointer = (event) => {
        if (this.dragging && (this.dragId === null || event.pointerId === this.dragId)) {
          this.dragging = false;
          this.carousel.classList.remove('mc-dragging');

          try {
            if (this.carousel.hasPointerCapture(event.pointerId)) {
              this.carousel.releasePointerCapture(event.pointerId);
            }
          } catch {}

          this.dragId = null;
          this.center(this.closestCard(), this.reduced.matches ? 'auto' : 'smooth');
        }

        this.endInteraction();
      };

      this.carousel.addEventListener('pointerup', endPointer, { passive: true, signal });
      this.carousel.addEventListener('pointercancel', endPointer, { passive: true, signal });

      this.carousel.addEventListener('wheel', (event) => {
        const horizontal = Math.abs(event.deltaX) > Math.abs(event.deltaY);
        const shifted = event.shiftKey && Math.abs(event.deltaY) > 0;

        if (!horizontal && !shifted) return;

        event.preventDefault();
        this.beginInteraction();
        this.carousel.scrollLeft += horizontal ? event.deltaX : event.deltaY;
        this.endInteraction();
      }, { passive: false, signal });

      this.carousel.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.closeDetails();
          this.beginInteraction();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
          this.endInteraction();
        } else if (event.key === 'Escape') {
          this.closeDetails(true);
        }
      }, { signal });

      this.addEventListener('click', (event) => this.onClick(event), { signal });

      document.addEventListener('visibilitychange', () => {
        document.hidden ? this.stopAuto() : this.scheduleAuto();
      }, { signal });

      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          this.center(this.cards[this.activeIndex] || this.cards[0], 'auto');
          this.scheduleAuto();
        }, 100);
      }, { passive: true, signal });

      if ('IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver((entries) => {
          this.visible = Boolean(entries[0]?.isIntersecting);
          this.visible ? this.scheduleAuto() : this.stopAuto();
        }, {
          threshold: 0.01,
          rootMargin: `${this.lead}px 0px`
        });

        this.visibilityObserver.observe(this);
      } else {
        this.visible = true;
      }

      this.center(this.cards[0], 'auto');
      this.carousel.classList.add('mc-ready');
      this.ready = true;
      this.scheduleAuto();
    }

    addEdgeClones() {
      const count = this.cards.length;
      this.leadingExtra = this.cloneCard(this.cards[count - 2]);
      this.leading = this.cloneCard(this.cards[count - 1]);
      this.trailing = this.cloneCard(this.cards[0]);
      this.trailingExtra = this.cloneCard(this.cards[1]);

      this.carousel.prepend(this.leadingExtra, this.leading);
      this.carousel.append(this.trailing, this.trailingExtra);
    }

    cloneCard(card) {
      const clone = card.cloneNode(true);

      clone.dataset.mcClone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('role');
      clone.removeAttribute('aria-label');
      clone.removeAttribute('data-shopify-editor-block');
      clone.classList.remove('mc-active', 'mc-show-info');

      clone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));

      clone.querySelectorAll('[aria-controls], [aria-labelledby]').forEach((node) => {
        node.removeAttribute('aria-controls');
        node.removeAttribute('aria-labelledby');
      });

      clone.querySelectorAll('button, a, input, select, textarea').forEach((node) => {
        node.tabIndex = -1;
      });

      clone.querySelectorAll('[data-mc-details]').forEach((node) => {
        node.setAttribute('aria-hidden', 'true');
      });

      clone.querySelectorAll('[data-mc-open]').forEach((node) => {
        node.setAttribute('aria-expanded', 'false');
      });

      clone.querySelectorAll('img').forEach((image) => {
        image.loading = 'lazy';
        image.decoding = 'async';
      });

      return clone;
    }

    closestCard() {
      const center = this.carousel.scrollLeft + this.carousel.clientWidth / 2;
      let closest = null;
      let best = Infinity;

      for (const card of this.trackCards) {
        const distance = Math.abs(
          card.offsetLeft + card.offsetWidth / 2 - center
        );

        if (distance < best) {
          best = distance;
          closest = card;
        }
      }

      return closest;
    }

    setActive(card) {
      if (!card) return;

      const index = Number(card.dataset.index);
      if (Number.isFinite(index)) this.activeIndex = index;

      if (card === this.activeCard) return;

      this.activeCard?.classList.remove('mc-active');
      card.classList.add('mc-active');
      this.activeCard = card;
    }

    cancelSlide() {
      cancelAnimationFrame(this.slideRaf);
      this.slideRaf = 0;
      this.isAnimating = false;
      this.carousel.classList.remove('mc-animating');
    }

    center(card, behavior = 'smooth') {
      if (!card) return;

      const target = Math.max(0, Math.min(
        this.carousel.scrollWidth - this.carousel.clientWidth,
        card.offsetLeft - (this.carousel.clientWidth - card.offsetWidth) / 2
      ));
      const start = this.carousel.scrollLeft;
      const distance = target - start;

      this.cancelSlide();
      clearTimeout(this.scrollTimer);

      if (behavior !== 'smooth' || this.reduced.matches || Math.abs(distance) < 1) {
        this.carousel.scrollLeft = target;
        this.setActive(card);
        if (this.ready) this.finishScroll();
        return;
      }

      // Scroll via requestAnimationFrame to control speed and direction reliably.
      this.isAnimating = true;
      this.carousel.classList.add('mc-animating');

      const duration = 920;
      let startedAt = null;

      const animate = (now) => {
        if (startedAt === null) startedAt = now;
        const progress = Math.min((now - startedAt) / duration, 1);
        const eased = progress * progress * (3 - 2 * progress);
        this.carousel.scrollLeft = start + distance * eased;

        if (progress < 1) {
          this.slideRaf = requestAnimationFrame(animate);
          return;
        }

        this.slideRaf = 0;
        this.carousel.scrollLeft = target;
        this.isAnimating = false;
        this.finishScroll();
        this.carousel.classList.remove('mc-animating');
        this.scheduleAuto();
      };

      this.slideRaf = requestAnimationFrame(animate);
    }

    move(direction) {
      if (this.cards.length < 2 || this.jumping) return;

      const index = this.activeIndex;
      let target;

      if (direction > 0) {
        target = index >= this.cards.length - 1
          ? this.trailing
          : this.cards[index + 1];
      } else {
        target = index <= 0
          ? this.leading
          : this.cards[index - 1];
      }

      this.center(target, this.reduced.matches ? 'auto' : 'smooth');
    }

    onScroll() {
      if (this.jumping) return;

      if (!this.scrollRaf) {
        this.scrollRaf = requestAnimationFrame(() => {
          this.scrollRaf = 0;
          if (!this.jumping) this.setActive(this.closestCard());
        });
      }

      clearTimeout(this.scrollTimer);
      // Never interrupt a running slide to snap instantly to a clone.
      if (!this.isAnimating && !this.dragging) {
        this.scrollTimer = setTimeout(() => this.finishScroll(), 180);
      }
    }

    finishScroll() {
      if (this.isAnimating || this.dragging || this.jumping) return;

      const card = this.closestCard();
      if (!card) return;

      this.setActive(card);
      if (!card.dataset.mcClone) return;

      const index = Number(card.dataset.index);
      const realCard = this.cards[Number.isFinite(index) ? index : 0];
      if (!realCard) return;

      // The extra edge clones make the visible neighbours match on both sides,
      // so the internal infinite-loop reset is not perceptible.
      this.jumping = true;
      this.carousel.classList.add('mc-loop-reset');
      void this.carousel.offsetWidth;
      this.carousel.scrollLeft = realCard.offsetLeft -
        (this.carousel.clientWidth - realCard.offsetWidth) / 2;
      this.setActive(realCard);

      cancelAnimationFrame(this.loopRaf);
      this.loopRaf = requestAnimationFrame(() => {
        this.loopRaf = 0;
        this.carousel.classList.remove('mc-loop-reset');
        this.jumping = false;
        this.scheduleAuto();
      });
    }

    canAuto() {
      return (
        this.autoplay &&
        this.cards.length > 1 &&
        this.ready &&
        this.visible &&
        !document.hidden &&
        !this.interacting &&
        !this.openCard &&
        !this.dragging &&
        !this.isAnimating &&
        !this.jumping
      );
    }

    stopAuto() {
      clearTimeout(this.autoTimer);
      this.autoTimer = 0;
    }

    scheduleAuto() {
      this.stopAuto();
      if (!this.canAuto()) return;

      this.autoTimer = setTimeout(() => {
        this.autoTimer = 0;

        if (!this.canAuto()) {
          this.scheduleAuto();
          return;
        }

        this.move(1);
      }, this.interval);
    }

    beginInteraction() {
      this.interacting = true;

      this.cancelSlide();

      clearTimeout(this.interactionTimer);
      this.stopAuto();
    }

    endInteraction() {
      clearTimeout(this.interactionTimer);

      this.interactionTimer = setTimeout(() => {
        this.interacting = false;
        this.scheduleAuto();
      }, 900);
    }

    onClick(event) {
      const prev = event.target.closest('[data-mc-prev]');
      const next = event.target.closest('[data-mc-next]');
      const open = event.target.closest('[data-mc-open]');
      const close = event.target.closest('[data-mc-close]');

      if (prev || next) {
        this.closeDetails();
        this.beginInteraction();
        this.move(next ? 1 : -1);
        this.endInteraction();
        return;
      }

      if (open) {
        const card = open.closest('[data-mc-card]');
        if (!card || card.dataset.mcClone) return;

        this.openDetails(card, open);
        return;
      }

      if (close) {
        const card = close.closest('[data-mc-card]');
        if (card) this.closeDetails(true, card);
      }
    }

    openDetails(card, button) {
      if (this.openCard && this.openCard !== card) {
        this.closeDetails(false);
      }

      this.center(card, this.reduced.matches ? 'auto' : 'smooth');

      card.classList.add('mc-show-info');
      button.classList.add('mc-hidden');
      button.setAttribute('aria-expanded', 'true');

      card.querySelector('[data-mc-details]')
        ?.setAttribute('aria-hidden', 'false');

      this.openCard = card;
      this.stopAuto();
    }

    closeDetails(focus = false, card = this.openCard) {
      if (!card) return;

      card.classList.remove('mc-show-info');

      const button = card.querySelector('[data-mc-open]');
      button?.classList.remove('mc-hidden');
      button?.setAttribute('aria-expanded', 'false');

      card.querySelector('[data-mc-details]')
        ?.setAttribute('aria-hidden', 'true');

      if (this.openCard === card) this.openCard = null;
      if (focus) button?.focus();

      this.scheduleAuto();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this._mountFrame);
      cancelAnimationFrame(this.scrollRaf);
      cancelAnimationFrame(this.slideRaf);
      cancelAnimationFrame(this.loopRaf);

      clearTimeout(this.autoTimer);
      clearTimeout(this.interactionTimer);
      clearTimeout(this.scrollTimer);
      clearTimeout(this.resizeTimer);

      this.visibilityObserver?.disconnect();
      this.controller?.abort();

      this.leadingExtra?.remove();
      this.leading?.remove();
      this.trailing?.remove();
      this.trailingExtra?.remove();

      this.controller = null;
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velune-leather-material-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('velune-material-carousel-lite')) {
  customElements.define('velune-material-carousel-lite', class extends HTMLElement {
    connectedCallback() {
      if (this._mountFrame) return;
      this._mountFrame = requestAnimationFrame(() => {
        this._mountFrame = 0;
        this.mount();
      });
    }

    mount() {
      if (this.controller || !this.isConnected) return;

      this.carousel = this.querySelector('[data-mc-carousel]');
      this.cards = Array.from(this.querySelectorAll('[data-mc-card]'));

      if (!this.carousel || !this.cards.length) return;

      this.controller = new AbortController();
      const signal = this.controller.signal;

      this.interval = Math.max(2000, Number(this.dataset.interval) || 3000);
      this.lead = Math.max(0, Number(this.dataset.lead) || 0);
      this.autoplay = this.dataset.autoplay !== 'false';
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.activeIndex = 0;
      this.activeCard = this.cards[0];
      this.openCard = null;
      this.visible = false;
      this.interacting = false;
      this.dragging = false;
      this.jumping = false;
      this.isAnimating = false;
      this.dragId = null;

      if (this.cards.length > 1) this.addEdgeClones();
      this.trackCards = Array.from(this.carousel.querySelectorAll('.mc-card'));

      this.carousel.addEventListener('scroll', () => this.onScroll(), {
        passive: true,
        signal
      });

      this.carousel.addEventListener('pointerdown', (event) => {
        this.beginInteraction();

        if (
          event.pointerType !== 'mouse' ||
          event.button !== 0 ||
          event.target.closest('button, a, input, select, textarea')
        ) return;

        this.dragging = true;
        this.dragId = event.pointerId;
        this.dragX = event.clientX;
        this.dragScroll = this.carousel.scrollLeft;
        this.carousel.classList.add('mc-dragging');

        try { this.carousel.setPointerCapture(event.pointerId); } catch {}
      }, { passive: true, signal });

      this.carousel.addEventListener('pointermove', (event) => {
        if (!this.dragging || event.pointerId !== this.dragId) return;
        this.carousel.scrollLeft = this.dragScroll - (event.clientX - this.dragX);
        event.preventDefault();
      }, { passive: false, signal });

      const endPointer = (event) => {
        if (this.dragging && (this.dragId === null || event.pointerId === this.dragId)) {
          this.dragging = false;
          this.carousel.classList.remove('mc-dragging');

          try {
            if (this.carousel.hasPointerCapture(event.pointerId)) {
              this.carousel.releasePointerCapture(event.pointerId);
            }
          } catch {}

          this.dragId = null;
          this.center(this.closestCard(), this.reduced.matches ? 'auto' : 'smooth');
        }

        this.endInteraction();
      };

      this.carousel.addEventListener('pointerup', endPointer, { passive: true, signal });
      this.carousel.addEventListener('pointercancel', endPointer, { passive: true, signal });

      this.carousel.addEventListener('wheel', (event) => {
        const horizontal = Math.abs(event.deltaX) > Math.abs(event.deltaY);
        const shifted = event.shiftKey && Math.abs(event.deltaY) > 0;

        if (!horizontal && !shifted) return;

        event.preventDefault();
        this.beginInteraction();
        this.carousel.scrollLeft += horizontal ? event.deltaX : event.deltaY;
        this.endInteraction();
      }, { passive: false, signal });

      this.carousel.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.closeDetails();
          this.beginInteraction();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
          this.endInteraction();
        } else if (event.key === 'Escape') {
          this.closeDetails(true);
        }
      }, { signal });

      this.addEventListener('click', (event) => this.onClick(event), { signal });

      document.addEventListener('visibilitychange', () => {
        document.hidden ? this.stopAuto() : this.scheduleAuto();
      }, { signal });

      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          this.center(this.cards[this.activeIndex] || this.cards[0], 'auto');
          this.scheduleAuto();
        }, 100);
      }, { passive: true, signal });

      if ('IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver((entries) => {
          this.visible = Boolean(entries[0]?.isIntersecting);
          this.visible ? this.scheduleAuto() : this.stopAuto();
        }, {
          threshold: 0.01,
          rootMargin: `${this.lead}px 0px`
        });

        this.visibilityObserver.observe(this);
      } else {
        this.visible = true;
      }

      this.center(this.cards[0], 'auto');
      this.carousel.classList.add('mc-ready');
      this.ready = true;
      this.scheduleAuto();
    }

    addEdgeClones() {
      const count = this.cards.length;
      this.leadingExtra = this.cloneCard(this.cards[count - 2]);
      this.leading = this.cloneCard(this.cards[count - 1]);
      this.trailing = this.cloneCard(this.cards[0]);
      this.trailingExtra = this.cloneCard(this.cards[1]);

      this.carousel.prepend(this.leadingExtra, this.leading);
      this.carousel.append(this.trailing, this.trailingExtra);
    }

    cloneCard(card) {
      const clone = card.cloneNode(true);

      clone.dataset.mcClone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('role');
      clone.removeAttribute('aria-label');
      clone.removeAttribute('data-shopify-editor-block');
      clone.classList.remove('mc-active', 'mc-show-info');

      clone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));

      clone.querySelectorAll('[aria-controls], [aria-labelledby]').forEach((node) => {
        node.removeAttribute('aria-controls');
        node.removeAttribute('aria-labelledby');
      });

      clone.querySelectorAll('button, a, input, select, textarea').forEach((node) => {
        node.tabIndex = -1;
      });

      clone.querySelectorAll('[data-mc-details]').forEach((node) => {
        node.setAttribute('aria-hidden', 'true');
      });

      clone.querySelectorAll('[data-mc-open]').forEach((node) => {
        node.setAttribute('aria-expanded', 'false');
      });

      clone.querySelectorAll('img').forEach((image) => {
        image.loading = 'lazy';
        image.decoding = 'async';
      });

      return clone;
    }

    closestCard() {
      const center = this.carousel.scrollLeft + this.carousel.clientWidth / 2;
      let closest = null;
      let best = Infinity;

      for (const card of this.trackCards) {
        const distance = Math.abs(
          card.offsetLeft + card.offsetWidth / 2 - center
        );

        if (distance < best) {
          best = distance;
          closest = card;
        }
      }

      return closest;
    }

    setActive(card) {
      if (!card) return;

      const index = Number(card.dataset.index);
      if (Number.isFinite(index)) this.activeIndex = index;

      if (card === this.activeCard) return;

      this.activeCard?.classList.remove('mc-active');
      card.classList.add('mc-active');
      this.activeCard = card;
    }

    cancelSlide() {
      cancelAnimationFrame(this.slideRaf);
      this.slideRaf = 0;
      this.isAnimating = false;
      this.carousel.classList.remove('mc-animating');
    }

    center(card, behavior = 'smooth') {
      if (!card) return;

      const target = Math.max(0, Math.min(
        this.carousel.scrollWidth - this.carousel.clientWidth,
        card.offsetLeft - (this.carousel.clientWidth - card.offsetWidth) / 2
      ));
      const start = this.carousel.scrollLeft;
      const distance = target - start;

      this.cancelSlide();
      clearTimeout(this.scrollTimer);

      if (behavior !== 'smooth' || this.reduced.matches || Math.abs(distance) < 1) {
        this.carousel.scrollLeft = target;
        this.setActive(card);
        if (this.ready) this.finishScroll();
        return;
      }

      // Scroll via requestAnimationFrame to control speed and direction reliably.
      this.isAnimating = true;
      this.carousel.classList.add('mc-animating');

      const duration = 920;
      let startedAt = null;

      const animate = (now) => {
        if (startedAt === null) startedAt = now;
        const progress = Math.min((now - startedAt) / duration, 1);
        const eased = progress * progress * (3 - 2 * progress);
        this.carousel.scrollLeft = start + distance * eased;

        if (progress < 1) {
          this.slideRaf = requestAnimationFrame(animate);
          return;
        }

        this.slideRaf = 0;
        this.carousel.scrollLeft = target;
        this.isAnimating = false;
        this.finishScroll();
        this.carousel.classList.remove('mc-animating');
        this.scheduleAuto();
      };

      this.slideRaf = requestAnimationFrame(animate);
    }

    move(direction) {
      if (this.cards.length < 2 || this.jumping) return;

      const index = this.activeIndex;
      let target;

      if (direction > 0) {
        target = index >= this.cards.length - 1
          ? this.trailing
          : this.cards[index + 1];
      } else {
        target = index <= 0
          ? this.leading
          : this.cards[index - 1];
      }

      this.center(target, this.reduced.matches ? 'auto' : 'smooth');
    }

    onScroll() {
      if (this.jumping) return;

      if (!this.scrollRaf) {
        this.scrollRaf = requestAnimationFrame(() => {
          this.scrollRaf = 0;
          if (!this.jumping) this.setActive(this.closestCard());
        });
      }

      clearTimeout(this.scrollTimer);
      // Never interrupt a running slide to snap instantly to a clone.
      if (!this.isAnimating && !this.dragging) {
        this.scrollTimer = setTimeout(() => this.finishScroll(), 180);
      }
    }

    finishScroll() {
      if (this.isAnimating || this.dragging || this.jumping) return;

      const card = this.closestCard();
      if (!card) return;

      this.setActive(card);
      if (!card.dataset.mcClone) return;

      const index = Number(card.dataset.index);
      const realCard = this.cards[Number.isFinite(index) ? index : 0];
      if (!realCard) return;

      // The extra edge clones make the visible neighbours match on both sides,
      // so the internal infinite-loop reset is not perceptible.
      this.jumping = true;
      this.carousel.classList.add('mc-loop-reset');
      void this.carousel.offsetWidth;
      this.carousel.scrollLeft = realCard.offsetLeft -
        (this.carousel.clientWidth - realCard.offsetWidth) / 2;
      this.setActive(realCard);

      cancelAnimationFrame(this.loopRaf);
      this.loopRaf = requestAnimationFrame(() => {
        this.loopRaf = 0;
        this.carousel.classList.remove('mc-loop-reset');
        this.jumping = false;
        this.scheduleAuto();
      });
    }

    canAuto() {
      return (
        this.autoplay &&
        this.cards.length > 1 &&
        this.ready &&
        this.visible &&
        !document.hidden &&
        !this.interacting &&
        !this.openCard &&
        !this.dragging &&
        !this.isAnimating &&
        !this.jumping
      );
    }

    stopAuto() {
      clearTimeout(this.autoTimer);
      this.autoTimer = 0;
    }

    scheduleAuto() {
      this.stopAuto();
      if (!this.canAuto()) return;

      this.autoTimer = setTimeout(() => {
        this.autoTimer = 0;

        if (!this.canAuto()) {
          this.scheduleAuto();
          return;
        }

        this.move(1);
      }, this.interval);
    }

    beginInteraction() {
      this.interacting = true;

      this.cancelSlide();

      clearTimeout(this.interactionTimer);
      this.stopAuto();
    }

    endInteraction() {
      clearTimeout(this.interactionTimer);

      this.interactionTimer = setTimeout(() => {
        this.interacting = false;
        this.scheduleAuto();
      }, 900);
    }

    onClick(event) {
      const prev = event.target.closest('[data-mc-prev]');
      const next = event.target.closest('[data-mc-next]');
      const open = event.target.closest('[data-mc-open]');
      const close = event.target.closest('[data-mc-close]');

      if (prev || next) {
        this.closeDetails();
        this.beginInteraction();
        this.move(next ? 1 : -1);
        this.endInteraction();
        return;
      }

      if (open) {
        const card = open.closest('[data-mc-card]');
        if (!card || card.dataset.mcClone) return;

        this.openDetails(card, open);
        return;
      }

      if (close) {
        const card = close.closest('[data-mc-card]');
        if (card) this.closeDetails(true, card);
      }
    }

    openDetails(card, button) {
      if (this.openCard && this.openCard !== card) {
        this.closeDetails(false);
      }

      this.center(card, this.reduced.matches ? 'auto' : 'smooth');

      card.classList.add('mc-show-info');
      button.classList.add('mc-hidden');
      button.setAttribute('aria-expanded', 'true');

      card.querySelector('[data-mc-details]')
        ?.setAttribute('aria-hidden', 'false');

      this.openCard = card;
      this.stopAuto();
    }

    closeDetails(focus = false, card = this.openCard) {
      if (!card) return;

      card.classList.remove('mc-show-info');

      const button = card.querySelector('[data-mc-open]');
      button?.classList.remove('mc-hidden');
      button?.setAttribute('aria-expanded', 'false');

      card.querySelector('[data-mc-details]')
        ?.setAttribute('aria-hidden', 'true');

      if (this.openCard === card) this.openCard = null;
      if (focus) button?.focus();

      this.scheduleAuto();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this._mountFrame);
      cancelAnimationFrame(this.scrollRaf);
      cancelAnimationFrame(this.slideRaf);
      cancelAnimationFrame(this.loopRaf);

      clearTimeout(this.autoTimer);
      clearTimeout(this.interactionTimer);
      clearTimeout(this.scrollTimer);
      clearTimeout(this.resizeTimer);

      this.visibilityObserver?.disconnect();
      this.controller?.abort();

      this.leadingExtra?.remove();
      this.leading?.remove();
      this.trailing?.remove();
      this.trailingExtra?.remove();

      this.controller = null;
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velune-travel-material-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('velune-material-carousel-lite')) {
  customElements.define('velune-material-carousel-lite', class extends HTMLElement {
    connectedCallback() {
      if (this._mountFrame) return;
      this._mountFrame = requestAnimationFrame(() => {
        this._mountFrame = 0;
        this.mount();
      });
    }

    mount() {
      if (this.controller || !this.isConnected) return;

      this.carousel = this.querySelector('[data-mc-carousel]');
      this.cards = Array.from(this.querySelectorAll('[data-mc-card]'));

      if (!this.carousel || !this.cards.length) return;

      this.controller = new AbortController();
      const signal = this.controller.signal;

      this.interval = Math.max(2000, Number(this.dataset.interval) || 3000);
      this.lead = Math.max(0, Number(this.dataset.lead) || 0);
      this.autoplay = this.dataset.autoplay !== 'false';
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.activeIndex = 0;
      this.activeCard = this.cards[0];
      this.openCard = null;
      this.visible = false;
      this.interacting = false;
      this.dragging = false;
      this.jumping = false;
      this.isAnimating = false;
      this.dragId = null;

      if (this.cards.length > 1) this.addEdgeClones();
      this.trackCards = Array.from(this.carousel.querySelectorAll('.mc-card'));

      this.carousel.addEventListener('scroll', () => this.onScroll(), {
        passive: true,
        signal
      });

      this.carousel.addEventListener('pointerdown', (event) => {
        this.beginInteraction();

        if (
          event.pointerType !== 'mouse' ||
          event.button !== 0 ||
          event.target.closest('button, a, input, select, textarea')
        ) return;

        this.dragging = true;
        this.dragId = event.pointerId;
        this.dragX = event.clientX;
        this.dragScroll = this.carousel.scrollLeft;
        this.carousel.classList.add('mc-dragging');

        try { this.carousel.setPointerCapture(event.pointerId); } catch {}
      }, { passive: true, signal });

      this.carousel.addEventListener('pointermove', (event) => {
        if (!this.dragging || event.pointerId !== this.dragId) return;
        this.carousel.scrollLeft = this.dragScroll - (event.clientX - this.dragX);
        event.preventDefault();
      }, { passive: false, signal });

      const endPointer = (event) => {
        if (this.dragging && (this.dragId === null || event.pointerId === this.dragId)) {
          this.dragging = false;
          this.carousel.classList.remove('mc-dragging');

          try {
            if (this.carousel.hasPointerCapture(event.pointerId)) {
              this.carousel.releasePointerCapture(event.pointerId);
            }
          } catch {}

          this.dragId = null;
          this.center(this.closestCard(), this.reduced.matches ? 'auto' : 'smooth');
        }

        this.endInteraction();
      };

      this.carousel.addEventListener('pointerup', endPointer, { passive: true, signal });
      this.carousel.addEventListener('pointercancel', endPointer, { passive: true, signal });

      this.carousel.addEventListener('wheel', (event) => {
        const horizontal = Math.abs(event.deltaX) > Math.abs(event.deltaY);
        const shifted = event.shiftKey && Math.abs(event.deltaY) > 0;

        if (!horizontal && !shifted) return;

        event.preventDefault();
        this.beginInteraction();
        this.carousel.scrollLeft += horizontal ? event.deltaX : event.deltaY;
        this.endInteraction();
      }, { passive: false, signal });

      this.carousel.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.closeDetails();
          this.beginInteraction();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
          this.endInteraction();
        } else if (event.key === 'Escape') {
          this.closeDetails(true);
        }
      }, { signal });

      this.addEventListener('click', (event) => this.onClick(event), { signal });

      document.addEventListener('visibilitychange', () => {
        document.hidden ? this.stopAuto() : this.scheduleAuto();
      }, { signal });

      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          this.center(this.cards[this.activeIndex] || this.cards[0], 'auto');
          this.scheduleAuto();
        }, 100);
      }, { passive: true, signal });

      if ('IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver((entries) => {
          this.visible = Boolean(entries[0]?.isIntersecting);
          this.visible ? this.scheduleAuto() : this.stopAuto();
        }, {
          threshold: 0.01,
          rootMargin: `${this.lead}px 0px`
        });

        this.visibilityObserver.observe(this);
      } else {
        this.visible = true;
      }

      this.center(this.cards[0], 'auto');
      this.carousel.classList.add('mc-ready');
      this.ready = true;
      this.scheduleAuto();
    }

    addEdgeClones() {
      const count = this.cards.length;
      this.leadingExtra = this.cloneCard(this.cards[count - 2]);
      this.leading = this.cloneCard(this.cards[count - 1]);
      this.trailing = this.cloneCard(this.cards[0]);
      this.trailingExtra = this.cloneCard(this.cards[1]);

      this.carousel.prepend(this.leadingExtra, this.leading);
      this.carousel.append(this.trailing, this.trailingExtra);
    }

    cloneCard(card) {
      const clone = card.cloneNode(true);

      clone.dataset.mcClone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('role');
      clone.removeAttribute('aria-label');
      clone.removeAttribute('data-shopify-editor-block');
      clone.classList.remove('mc-active', 'mc-show-info');

      clone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));

      clone.querySelectorAll('[aria-controls], [aria-labelledby]').forEach((node) => {
        node.removeAttribute('aria-controls');
        node.removeAttribute('aria-labelledby');
      });

      clone.querySelectorAll('button, a, input, select, textarea').forEach((node) => {
        node.tabIndex = -1;
      });

      clone.querySelectorAll('[data-mc-details]').forEach((node) => {
        node.setAttribute('aria-hidden', 'true');
      });

      clone.querySelectorAll('[data-mc-open]').forEach((node) => {
        node.setAttribute('aria-expanded', 'false');
      });

      clone.querySelectorAll('img').forEach((image) => {
        image.loading = 'lazy';
        image.decoding = 'async';
      });

      return clone;
    }

    closestCard() {
      const center = this.carousel.scrollLeft + this.carousel.clientWidth / 2;
      let closest = null;
      let best = Infinity;

      for (const card of this.trackCards) {
        const distance = Math.abs(
          card.offsetLeft + card.offsetWidth / 2 - center
        );

        if (distance < best) {
          best = distance;
          closest = card;
        }
      }

      return closest;
    }

    setActive(card) {
      if (!card) return;

      const index = Number(card.dataset.index);
      if (Number.isFinite(index)) this.activeIndex = index;

      if (card === this.activeCard) return;

      this.activeCard?.classList.remove('mc-active');
      card.classList.add('mc-active');
      this.activeCard = card;
    }

    cancelSlide() {
      cancelAnimationFrame(this.slideRaf);
      this.slideRaf = 0;
      this.isAnimating = false;
      this.carousel.classList.remove('mc-animating');
    }

    center(card, behavior = 'smooth') {
      if (!card) return;

      const target = Math.max(0, Math.min(
        this.carousel.scrollWidth - this.carousel.clientWidth,
        card.offsetLeft - (this.carousel.clientWidth - card.offsetWidth) / 2
      ));
      const start = this.carousel.scrollLeft;
      const distance = target - start;

      this.cancelSlide();
      clearTimeout(this.scrollTimer);

      if (behavior !== 'smooth' || this.reduced.matches || Math.abs(distance) < 1) {
        this.carousel.scrollLeft = target;
        this.setActive(card);
        if (this.ready) this.finishScroll();
        return;
      }

      // Scroll via requestAnimationFrame to control speed and direction reliably.
      this.isAnimating = true;
      this.carousel.classList.add('mc-animating');

      const duration = 920;
      let startedAt = null;

      const animate = (now) => {
        if (startedAt === null) startedAt = now;
        const progress = Math.min((now - startedAt) / duration, 1);
        const eased = progress * progress * (3 - 2 * progress);
        this.carousel.scrollLeft = start + distance * eased;

        if (progress < 1) {
          this.slideRaf = requestAnimationFrame(animate);
          return;
        }

        this.slideRaf = 0;
        this.carousel.scrollLeft = target;
        this.isAnimating = false;
        this.finishScroll();
        this.carousel.classList.remove('mc-animating');
        this.scheduleAuto();
      };

      this.slideRaf = requestAnimationFrame(animate);
    }

    move(direction) {
      if (this.cards.length < 2 || this.jumping) return;

      const index = this.activeIndex;
      let target;

      if (direction > 0) {
        target = index >= this.cards.length - 1
          ? this.trailing
          : this.cards[index + 1];
      } else {
        target = index <= 0
          ? this.leading
          : this.cards[index - 1];
      }

      this.center(target, this.reduced.matches ? 'auto' : 'smooth');
    }

    onScroll() {
      if (this.jumping) return;

      if (!this.scrollRaf) {
        this.scrollRaf = requestAnimationFrame(() => {
          this.scrollRaf = 0;
          if (!this.jumping) this.setActive(this.closestCard());
        });
      }

      clearTimeout(this.scrollTimer);
      // Never interrupt a running slide to snap instantly to a clone.
      if (!this.isAnimating && !this.dragging) {
        this.scrollTimer = setTimeout(() => this.finishScroll(), 180);
      }
    }

    finishScroll() {
      if (this.isAnimating || this.dragging || this.jumping) return;

      const card = this.closestCard();
      if (!card) return;

      this.setActive(card);
      if (!card.dataset.mcClone) return;

      const index = Number(card.dataset.index);
      const realCard = this.cards[Number.isFinite(index) ? index : 0];
      if (!realCard) return;

      // The extra edge clones make the visible neighbours match on both sides,
      // so the internal infinite-loop reset is not perceptible.
      this.jumping = true;
      this.carousel.classList.add('mc-loop-reset');
      void this.carousel.offsetWidth;
      this.carousel.scrollLeft = realCard.offsetLeft -
        (this.carousel.clientWidth - realCard.offsetWidth) / 2;
      this.setActive(realCard);

      cancelAnimationFrame(this.loopRaf);
      this.loopRaf = requestAnimationFrame(() => {
        this.loopRaf = 0;
        this.carousel.classList.remove('mc-loop-reset');
        this.jumping = false;
        this.scheduleAuto();
      });
    }

    canAuto() {
      return (
        this.autoplay &&
        this.cards.length > 1 &&
        this.ready &&
        this.visible &&
        !document.hidden &&
        !this.interacting &&
        !this.openCard &&
        !this.dragging &&
        !this.isAnimating &&
        !this.jumping
      );
    }

    stopAuto() {
      clearTimeout(this.autoTimer);
      this.autoTimer = 0;
    }

    scheduleAuto() {
      this.stopAuto();
      if (!this.canAuto()) return;

      this.autoTimer = setTimeout(() => {
        this.autoTimer = 0;

        if (!this.canAuto()) {
          this.scheduleAuto();
          return;
        }

        this.move(1);
      }, this.interval);
    }

    beginInteraction() {
      this.interacting = true;

      this.cancelSlide();

      clearTimeout(this.interactionTimer);
      this.stopAuto();
    }

    endInteraction() {
      clearTimeout(this.interactionTimer);

      this.interactionTimer = setTimeout(() => {
        this.interacting = false;
        this.scheduleAuto();
      }, 900);
    }

    onClick(event) {
      const prev = event.target.closest('[data-mc-prev]');
      const next = event.target.closest('[data-mc-next]');
      const open = event.target.closest('[data-mc-open]');
      const close = event.target.closest('[data-mc-close]');

      if (prev || next) {
        this.closeDetails();
        this.beginInteraction();
        this.move(next ? 1 : -1);
        this.endInteraction();
        return;
      }

      if (open) {
        const card = open.closest('[data-mc-card]');
        if (!card || card.dataset.mcClone) return;

        this.openDetails(card, open);
        return;
      }

      if (close) {
        const card = close.closest('[data-mc-card]');
        if (card) this.closeDetails(true, card);
      }
    }

    openDetails(card, button) {
      if (this.openCard && this.openCard !== card) {
        this.closeDetails(false);
      }

      this.center(card, this.reduced.matches ? 'auto' : 'smooth');

      card.classList.add('mc-show-info');
      button.classList.add('mc-hidden');
      button.setAttribute('aria-expanded', 'true');

      card.querySelector('[data-mc-details]')
        ?.setAttribute('aria-hidden', 'false');

      this.openCard = card;
      this.stopAuto();
    }

    closeDetails(focus = false, card = this.openCard) {
      if (!card) return;

      card.classList.remove('mc-show-info');

      const button = card.querySelector('[data-mc-open]');
      button?.classList.remove('mc-hidden');
      button?.setAttribute('aria-expanded', 'false');

      card.querySelector('[data-mc-details]')
        ?.setAttribute('aria-hidden', 'true');

      if (this.openCard === card) this.openCard = null;
      if (focus) button?.focus();

      this.scheduleAuto();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this._mountFrame);
      cancelAnimationFrame(this.scrollRaf);
      cancelAnimationFrame(this.slideRaf);
      cancelAnimationFrame(this.loopRaf);

      clearTimeout(this.autoTimer);
      clearTimeout(this.interactionTimer);
      clearTimeout(this.scrollTimer);
      clearTimeout(this.resizeTimer);

      this.visibilityObserver?.disconnect();
      this.controller?.abort();

      this.leadingExtra?.remove();
      this.leading?.remove();
      this.trailing?.remove();
      this.trailingExtra?.remove();

      this.controller = null;
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
